/**
 * 素材类型
 * @type {{Text: number, Image: number}}
 */
export const MaterialType = {
  // 图片素材
  Image: 1,
  // 文本素材
  Text: 2
};

/**
 * 图层最大数量
 * @type {number}
 */
export const LayersMaximum = 5

/**
 * 厘米与英寸换算：1 英寸 = 2.54 厘米
 * @type {number}
 */
export const CM_PER_INCH = 2.54

/**
 * DTG 打印台板物理尺寸（单位：cm）
 * 画布（台板）始终以厘米为准，仅「打印尺寸/位置」面板以英寸展示，展示时再换算
 * 当前台板规格统一为 44×54cm，如需支持多规格可在此扩展
 * @type {number}
 */
export const PLATEN_WIDTH_CM = 44
export const PLATEN_HEIGHT_CM = 54

/**
 * DTG 打印台板物理尺寸（单位：in），由厘米换算而来，用于「打印尺寸/位置」面板展示
 * @type {number}
 */
export const PLATEN_WIDTH_IN = PLATEN_WIDTH_CM / CM_PER_INCH
export const PLATEN_HEIGHT_IN = PLATEN_HEIGHT_CM / CM_PER_INCH

/**
 * 后领（Back Collar）打印区域物理尺寸（单位：cm）
 * 规格为 4×4 英寸（10.16×10.16 cm），face id = 3
 * @type {number}
 */
export const BACK_COLLAR_WIDTH_CM = 10.16
export const BACK_COLLAR_HEIGHT_CM = 10.16

/**
 * 后领（Back Collar）打印区域物理尺寸（单位：in）
 * @type {number}
 */
export const BACK_COLLAR_WIDTH_IN = BACK_COLLAR_WIDTH_CM / CM_PER_INCH
export const BACK_COLLAR_HEIGHT_IN = BACK_COLLAR_HEIGHT_CM / CM_PER_INCH

/**
 * 后领（Back Collar）的 face id
 * @type {number}
 */
export const BACK_COLLAR_FACE_ID = 3

/**
 * 后领前端放大后的帧像素尺寸，视觉效果与正/背面设计框对齐
 * @type {number}
 */
export const BACK_COLLAR_FRAME_DISPLAY = 340